import React, { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { APIDATA_COLUMNS, APIDATA_COLUMNS_REAL } from "../../Values/tables";

import { filterStatus, searchAPIItem,getFormattedDateUpdated } from "../../Values/utils";
import moment from "moment";
import { getDateString, searchContacts } from "../../Values/utils";
import CustomTable from "../../Components/CustomTable/CustomTable";

import ApiModal from "../../Components/Modals/ApiModal/ApiModal";
import { fetchApiFilterData,checkApiSyncStatus,syncApiLeads } from "../../Services/organizations";
import NewImportProjectModal from "../../Components/Modals/ImportModal/NewImportProjectModal";
import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import NewImportApiModal from "../../Components/Modals/ImportModal/NewImportApiModal";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import styles from '../Analytics/Analytics.module.css';
import {themeColors} from "../../Components/theme";
import LeadSyncAlert from "../../Components/LeadSyncAlert/LeadSyncAlert";
import { url } from '../../Values/constants';
import axios from "axios";
import Loading from "../../Components/Loading/Loading";
import PopUpBox from "../AuditLogs/PopUpBox";
import { fetchApiData,fetchApiDataFilterValues } from "../../Services/apiData";
import { googleAnalytics } from "../../Services/users";
import { useHistory, useLocation } from "react-router-dom";
import {
  setCurrentRoute
} from "../../Redux/actions";

type props = {
  history: any;
  organizationId: any;
  user: any;
  theme: any;
  authToken:any;
  organizationData:any;
  filterObject: any;
  filterSort: any;
};

const ApiDataPanel: FunctionComponent<props> = ({
  history,
  organizationId,
  user,
  theme,
  authToken,
  organizationData,
  filterObject,
  filterSort
}) => {
  const dispatcher = useDispatch();
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [apiModal, setApiModal] = useState(false);
  const [API, setAPI] = useState<any[] | undefined>(undefined);
  const [status, setStatus] = useState("ALL");
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [apiFilter, setApiFilter] = useState("7");
  const [showImportModal, setShowImportModal] = useState(false);
  const [searchedItem, setsearchedItem] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [lastPage, setLastPage] = useState(-1);
  const [leadsNotSynced, setLeadsNotSynced] =  useState<any[]>([]);
  const [load, setLoad] = useState(false);
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [count, setCount] = useState<any>(0);
  const [isFinished, setIsFinished] = useState(false);
  const [isGACalled, setIsGACalled] = useState<any>(false);
    const [cRoute,setCRoute]=useState("") 
             const location: any = useLocation();                    
                                useEffect(() => {
                                  dispatcher(setCurrentRoute(location.pathname))
                                  setCRoute(location.pathname)
                                }, [location]);

  useEffect(() => {
    if (user.organization_id) {
      fetchApiData(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished,apiFilter);
    }
  }, [user]);

  useEffect(() => {
    setIsFinished(false);
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      fetchApiData(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished,apiFilter, false, pageSize, 1, false);
    }
  }, [filterObject, filterSort, searchQuery,apiFilter]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          fetchApiData(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished,apiFilter, false, pageSize);
        }
      } else {
        if (authToken) {
          fetchApiData(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished,apiFilter, true, pageSize);
        }
      }
    }
  }, [page, pageSize]);

  useEffect(() => {
    fetchApiDataFilterValues(user.organization_id, authToken, dispatcher);
  }, [user])

  // useEffect(() => {
  //   if (user.organization_id) {
      // if (apiFilter === "7") {
      //   let prevDate = moment().subtract(7, "day").toDate();
      //   let currentDate = moment().toDate();
      //   fetchApiFilterData(
      //     user.organization_id,
      //     (val) => setAPI(val),
      //     prevDate,
      //     currentDate
      //   );
      // } else if (apiFilter === "30") {
      //   let prevDate = moment().subtract(30, "day").toDate();
      //   let currentDate = moment().toDate();
      //   fetchApiFilterData(
      //     user.organization_id,
      //     (val) => setAPI(val),
      //     prevDate,
      //     currentDate
      //   );
      // } else {
      //   fetchApiData(user.organization_id, (val) => setAPI(val));
      // }
  //   }
  // }, [user, apiFilter]);

  // useEffect(() => {
  //   if (API) {
  //     let data: any[] = [];
  //     API.forEach((item) => {
  //       data.push(item);
  //     });
  //     setFilterData(data);
  //   }
  // }, [API]);

  // useEffect(() => {
  //   if (status === "ALL") {
  //     if (API) {
  //       const data = searchAPIItem(API, searchQuery);
  //       setTemporaryData(data);
  //       setFilterData(data);
  //     }
  //   } else {
  //     const data = searchAPIItem(temporaryData, searchQuery);
  //     setFilterData(data);
  //   }
  //   // eslint-disable-next-line
  // }, [searchQuery, API]);

  // useEffect(() => {
  //   if (searchQuery === "") {
  //     if (API) {
  //       const data = filterStatus(API, status);
  //       setTemporaryData(data);
  //       setFilterData(data);
  //     }
  //   } else {
  //     const data = filterStatus(temporaryData, status);
  //     setFilterData(data);
  //   }
  //   // eslint-disable-next-line
  // }, [status, API]);

  // let isFinished = false;
  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length !== 0) {
      selectedRowsData.forEach((item) => {
        data.push({
          "budget": item.budget,
          "Created By": item.created_by,
          "Property Stage": item.property_stage,
          "location": item.location,
          "Customer Name": item.customer_name,
          "Mobile Number": item.contact_no,
          "Alternate Number": item.alternate_no,
          "Country Code": item.country_code,
          "Associate Contact": item.associate_contact,
          "email": item.email,
          "campaign": item.campaign,
          "Add set": item.add_set,
          "Owner": item.contact_owner_email,
          "status": item.status,
          "created_at": getFormattedDateUpdated(item.created_at),
          "Lead Assign Date & Time": getFormattedDateUpdated(item.lead_assign_time),
          // "lead_id": item.lead_id,
          "property_type": item.property_type,
          "stage": item.stage,
          "Fail Reason": item.fail_reason,
          "project": item.project,
          "Lead Source": item.lead_source,
        });
      });
    }
    return data;
  };

  const syncLeads = () => {
    syncApiLeads(authToken,leadsNotSynced,setLoad,dispatcher)
  }

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Api_Data_Panel',user)
      }
    }
  },[user])

  return (
    <>
     <div className={styles.parent} style={{ display: "block", marginTop: "0px",...containerStyles}}>
     {load === true && <Loading />}
     {/* {leadsNotSynced.length > 0 && (<LeadSyncAlert syncLeads={syncLeads} leadsNotSynced={leadsNotSynced} />)} */}
      <div className={commonStyle.topBar} style={{ marginTop: "0px",...containerStyles }}> 
        <Topbar
          history={history}
          title={"Add Api Data"}
          path={"/addUsers"}
          onChange={(val) => setsearchQuery(val)}
          filterText="Status"
          setColumnModal={(data) => setColumnModal(data)}
          showStatusBox={true}
          setApiModal={(data) => setApiModal(data)}
          setStatus={(status) => setStatus(status)}
          status={status}
          setApiFilter={(data) => setApiFilter(data)}
          apiFilterData={apiFilter}
          onClick={() => {
            setShowImportModal(true);
          }}
          show={true}
          onExport={exportFile}
          selectedRows={selectedRows}
          setAuditLog={setAuditLog}
          isOtpVerified={isOtpVerified}
          panel = "api leads"
        />
      </div>
      <div className={commonStyle.parent} style={{minHeight:"450px",...containerStyles}}>
        {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
        <ApiCustomTable
        tableColumns={APIDATA_COLUMNS_REAL}
        tableRows={filterData}
        selectedRows={selectedRows}
        setSelectedRows={(data) => setSelectedRows(data)}
        tableType="API Leads"
        showColumnModal={columnModal}
        hideColumnModal={() => setColumnModal(false)}
        selectedRowsData={selectedRowsData}
        setSelectedRowsData={(data) => setSelectedRowsData(data)}
        // setSearchedItem={(val) => setsearchQuery(val)}
        setApiModal={(data) => {}}
        setApiEdit={(data) => {}}
        setApiData={(data) => {}}
        setPage={(val) => setPage(val)}
        setPageSize={(val) => setPageSize(val)}
        callApi={() => Promise.resolve()}
        pageSize={pageSize}
        page={page}
        isFinished={isFinished}
        totalCount={count}
        lastPage={lastPage}
      />
        
        :
        <ApiCustomTable
        tableColumns={APIDATA_COLUMNS}
        tableRows={filterData}
        selectedRows={selectedRows}
        setSelectedRows={(data) => setSelectedRows(data)}
        tableType="API Leads"
        showColumnModal={columnModal}
        hideColumnModal={() => setColumnModal(false)}
        selectedRowsData={selectedRowsData}
        setSelectedRowsData={(data) => setSelectedRowsData(data)}
        // setSearchedItem={(val) => setsearchQuery(val)}
        setApiModal={(data) => {}}
        setApiEdit={(data) => {}}
        setApiData={(data) => {}}
        setPage={(val) => setPage(val)}
        setPageSize={(val) => setPageSize(val)}
        callApi={() => Promise.resolve()}
        pageSize={pageSize}
        page={page}
        isFinished={isFinished}
        totalCount={count}
        lastPage={lastPage}
      />
        
        }
      </div>
      {showImportModal && (
        <NewImportApiModal
          open={showImportModal}
          close={() => setShowImportModal(false)}
          organization_id={user.organization_id}
          history={history}
          usersList={organizationId}
          user={user}
        />
      )}
      {apiModal === true && (
        <ApiModal open={apiModal} close={() => setApiModal(false)} />
      )}
       {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "api leads"
              />)}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    filterObject: state.apiDataFilter,
    filterSort: state.apiDataSort,
  };
};
export default connect(mapStateToProps)(ApiDataPanel);
